"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../../../..");
const utils_1 = require("../utils");
const Radio_styles_1 = require("./Radio.styles");
exports.Radio = react_1.default.forwardRef((_a, ref) => {
    var { id, checkedValue, label, dimension = "medium", theme = "traditional", outerProps, checkPlacement = "top-left", hasErrors = false, columns } = _a, props = __rest(_a, ["id", "checkedValue", "label", "dimension", "theme", "outerProps", "checkPlacement", "hasErrors", "columns"]);
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const isChecked = props.value && checkedValue ? checkedValue === props.value : false;
    const radioWrapperProps = {
        theme,
        disabled: props.disabled,
        dimension,
        isChecked,
        isFocused,
        checkPlacement,
        hasErrors,
    };
    const columnClassName = (0, utils_1.getColumnsClassName)(columns);
    const handleFocus = (e) => {
        props.onFocus && props.onFocus(e);
        setIsFocused(true);
    };
    const handleBlur = (e) => {
        props.onBlur && props.onBlur(e);
        setIsFocused(false);
    };
    return (react_1.default.createElement(Radio_styles_1.StyledRadioWrapper, Object.assign({}, radioWrapperProps, outerProps, { className: `${columnClassName}${columnClassName ? " " : ""}${(outerProps === null || outerProps === void 0 ? void 0 : outerProps.className) || ""}` }),
        react_1.default.createElement(__1.Text, { as: "label", skinny: true, props: { htmlFor: id, className: "custom-radio-label" } },
            react_1.default.createElement(Radio_styles_1.StyledRadioReplacement, Object.assign({}, radioWrapperProps)),
            react_1.default.createElement(Radio_styles_1.StyledRadioInput, Object.assign({}, props, { checked: isChecked, id: id, type: "radio", onFocus: handleFocus, onBlur: handleBlur, ref: ref })),
            react_1.default.createElement(Radio_styles_1.StyledRadioLabelInner, { checkPlacement: checkPlacement, theme: theme }, label))));
});
//# sourceMappingURL=Radio.js.map